module.exports = __webpack_public_path__ + "img/icon_check.f32144e5.png";